import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET google-fonts/v1/families
 */
export function fetch(query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('google-fonts/v1/families', {
    query
  });
}

/**
 * GET google-fonts/v1/families/{family}
 */
export function fetchFont(name, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`google-fonts/v1/families/${name}`);
}

/**
 * GET content/fonts/v1/by-asset-path/{path}
 */

export function fetchCustomFontsByAsset({
  family,
  path
}, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`content/fonts/v1/by-asset-path/${path}`, {
    query: {
      family
    }
  });
}

/**
 * GET /branding/v1/fonts-with-variants
 */

export function fetchCustomFonts(...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`/branding/v1/fonts-with-variants`);
}

/**
 * GET branding/v1/fonts-with-variants/{id}
 */

export function fetchCustomFont(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`branding/v1/fonts-with-variants/${id}`);
}

/**
 * POST branding/v1/fonts-with-variants
 * @param {Object} fontData Font creation data
 * @returns {Promise} created new font with font data
 */

export function createCustomFont(data, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post(`branding/v1/fonts-with-variants`, {
    data
  });
}

/**
 * PUT branding/v1/-with-variants
 * @param {Object} fontData Font edit data
 * @returns {Promise} edited font with updated data
 */

export function editCustomFont(data, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.put(`branding/v1/fonts-with-variants/${data.id}`, {
    data
  });
}

/**
 * DELETE /branding/fonts/{id}
 */

export function deleteCustomFont(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.delete(`/branding/v1/fonts/${id}`);
}